export function getImageDimensions(url: string): Promise<{ height: number; width: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve({ height: img.height, width: img.width }));
    img.addEventListener("error", reject);
    img.src = url;
  });
}

export const getImageDimensionsFromFile = async (
  file: File | Blob,
): Promise<{ width: number; height: number }> => {
  const url = URL.createObjectURL(file);

  return getImageDimensions(url);
};

export const getRelativeMaxDimensionsLocal = (
  { width, height }: { width: number; height: number },
  max: { width: number; height: number },
): { width: number; height: number } => {
  const scale = Math.min(1, max.width / width, max.height / height);
  return { width: width * scale, height: height * scale };
};
